
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";

import "@/store/modules/forms/form22";
const form22State = namespace("Form22");

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import { packageInfoType } from '@/types/Information';
import { form22DataInfoType, form22StatusInfoType } from '@/types/Information/Form22';

import Form22ProcessHeader from "@/components/process/Form22/components/Form22ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";

@Component({
    components:{
        Form22ProcessHeader,
        Spinner
    }
})
export default class SubmitForm22 extends Vue {    

    @form22State.State
    public currentNoFeesPayableId: string;

    @form22State.State
    public form22Info: form22DataInfoType;

    @form1State.Action
    public UpdateCurrentNoticeOfAppealId!: (newCurrentNoticeOfAppealId: string) => void

    stepsCompleted = {} as form22StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg="";   
    fileNumberExists = false;


    mounted() {
        this.mountedData = false;
        this.submitting = false;    
        this.errorMsg = ""
        this.fileNumberExists = !this.form22Info.requiresManualEntry && this.form22Info.formSevenNumber?.length > 0;
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg ="";

        const url = "/form22/efiling/"+this.currentNoFeesPayableId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }       
        
        this.$http.post(url, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });    
    }    
    
    public startNewForm1Document(){
        this.UpdateCurrentNoticeOfAppealId(null)
        this.$router.push({name: "checklist-form1" })
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
